import React from "react";
import { I18n } from "i18n-js";
import * as locales from "../../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";
import AnalyticsPageHeader from "./analyticsPageHeader";
import ParticipationCard from "./graphCards/participationCard";
import OrganizationCard from "./graphCards/organizationCard";
import FeedbackCard from "./graphCards/feedbackCard";
import BonusesCard from "./graphCards/bonusesCard";
import LeaderboardCard from "./graphCards/leaderboardCard";
import TopWordsCard from "./graphCards/topWordsCard";
import SuperBanner from "../reusable/superBanner";
import Spinner from "../reusable/spinner";

interface AnalyticsDashboardProps {
  fetchParticipationData?: any;
  fetchOrganizationData?: any;
  fetchLeaderboardData?: any;
  fetchBonusesData?: any;
  fetchTopWordsData?: any;
  devMode?: boolean;
  teamId?: string;
  teamName?: string;
  managerBasedTeam?: boolean;
  participation?: any;
  leaderboard?: any;
  organization?: any;
  bonuses?: any;
  topWords?: any;
  hideCompetitiveFeatures?: boolean;
  children?: React.ReactNode;
  showSuperBanner?: boolean;
  showPersistentBanner?: boolean;
}
interface AnalyticsDashboardState {
  buttonLoading: boolean;
}

export default class AnalyticsDashboard extends React.Component<
  AnalyticsDashboardProps,
  AnalyticsDashboardState
> {
  state: AnalyticsDashboardState = {
    buttonLoading: false,
  };

  render() {
    return (
      <div className="container medium">
        {this.renderBanner()}
        <AnalyticsPageHeader title={this.getPageHeader()} />
        <div className="col-md-12 col-lg-6 analytics-dashboard-col">
          <ParticipationCard
            {...this.props.participation}
            devMode={this.props.devMode}
            fetchParticipationData={this.props.fetchParticipationData}
          />
          <FeedbackCard />
          {this.props.hideCompetitiveFeatures
            ? null
            : this.renderLeaderboardCard()}
        </div>
        <div className="col-md-12 col-lg-6 analytics-dashboard-col">
          {this.renderOrganizationCard()}
          <BonusesCard
            {...this.props.bonuses}
            devMode={this.props.devMode}
            fetchBonusesData={this.props.fetchBonusesData}
          />
          <TopWordsCard
            {...this.props.topWords}
            devMode={this.props.devMode}
            fetchTopWordsData={this.props.fetchTopWordsData}
          />
        </div>
      </div>
    );
  }

  renderBanner = () => {
    if (!this.props.showSuperBanner && !this.props.showPersistentBanner) {
      return null;
    }

    if (this.props.showSuperBanner) {
      return this.renderSuperBanner();
    }

    return this.renderPersistentBanner();
  };

  renderSuperBanner = () => {
    return (
      <SuperBanner
        bannerMessage={this.superBannerMessage()}
        dropdownContent={this.superBannerDropdownContent()}
      />
    );
  };

  renderPersistentBanner = () => {
    return (
      <div className="persistent-banner">
        <p>
          <strong>
            {i18n.translate("analyticsv2.banner.sample_data_ahead")}
          </strong>
          &nbsp;
          {i18n.translate("analyticsv2.banner.use_bonusly")}
          &nbsp;
          <a href="https://blog.bonus.ly/product/analytics-dashboard">
            {i18n.translate("analyticsv2.banner.blog_link")}
          </a>
        </p>
      </div>
    );
  };

  renderLeaderboardCard = () => {
    return (
      <LeaderboardCard
        {...this.props.leaderboard}
        devMode={this.props.devMode}
        fetchLeaderboardData={this.props.fetchLeaderboardData}
        teamId={this.props.teamId}
      />
    );
  };

  renderOrganizationCard = () => {
    if (!this.props.managerBasedTeam) {
      return null;
    }

    return (
      <OrganizationCard
        {...this.props.organization}
        devMode={this.props.devMode}
        fetchOrganizationData={this.props.fetchOrganizationData}
        teamId={this.props.teamId}
      />
    );
  };

  getPageHeader = () => {
    return `Analytics for ${this.props.teamName}`;
  };

  superBannerDropdownContent = () => {
    return (
      <div className="dropdown-content">
        <h2>{i18n.translate("analyticsv2.banner.content_header")}</h2>
        <p>{i18n.translate("analyticsv2.banner.content_body")}</p>
        <a
          className="btn btn-danger btn-large"
          href="/company/settings/delete_sample_data"
          onClick={this.handleButtonClick}
        >
          {this.state.buttonLoading
            ? this.renderSpinner()
            : i18n.translate("analyticsv2.banner.delete_button_text")}
        </a>
        <div className="clear" />
      </div>
    );
  };

  handleButtonClick = (e) => {
    e.stopPropagation();

    if (this.confirmDeletion()) {
      this.showButtonSpinner();
    } else {
      e.preventDefault();
    }
  };

  showButtonSpinner = () => {
    this.setState(() => {
      return { buttonLoading: true };
    });
  };

  confirmDeletion = () => {
    return window.confirm(i18n.translate("analyticsv2.banner.are_you_sure")); // eslint-disable-line no-alert
  };

  superBannerMessage = () => {
    return (
      <p>
        <strong>{i18n.translate("analyticsv2.banner.header_refresh")}</strong>
        {i18n.translate("analyticsv2.banner.header_delete")}
      </p>
    );
  };

  renderSpinner = () => {
    return <Spinner />;
  };
}
